import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const callNotificationsReducer = combineReducers({
  list,
  view,
});

export default callNotificationsReducer;
